/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_SlugInputs */

const cs_blog_slug = /** @type {(inputs: Blog_SlugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL slug`)
};

const en_blog_slug = /** @type {(inputs: Blog_SlugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL slug`)
};

/**
* | output |
* | --- |
* | "URL slug" |
*
* @param {Blog_SlugInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_slug = /** @type {((inputs?: Blog_SlugInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_SlugInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_slug(inputs)
	return cs_blog_slug(inputs)
});